import React from 'react';
import ReactDOM from 'react-dom';
import Amplify from 'aws-amplify';
import { Provider } from 'react-redux';
import { store } from 'antd/redux/store';
import App from './App';
import { PropertyEditProvider } from './contexts/PropertyEditContext';
import awsExports from './aws-exports.js';

Amplify.configure(awsExports);
ReactDOM.render(
  <Provider store={store}>
    <PropertyEditProvider>
      <App />
    </PropertyEditProvider>
  </Provider>,
  document.getElementById('root')
);
